import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import UpgradedBackdropSvg from 'assets/booths/711-upgraded/BoothBackdrop';
import { FETCH_ASSETS_URL } from 'appenv';

const Booth711Borders = `${FETCH_ASSETS_URL}/assets/booths/711-upgraded/booth-border.svg`;
const UpgradedBoothLines = `${FETCH_ASSETS_URL}/assets/booths/711-upgraded/booth-lines.svg`;
const BoothTemplate04Backdrop = `${FETCH_ASSETS_URL}/assets/booths/booth4/booth.png`;

const UpgradedBackdrop = styled(UpgradedBackdropSvg)<{ color: string }>`
  display: block;
  position: absolute;
  top: -31px;
  width: 100%;
  height: 100%;
`;

const UpgradedBoothLinesImage = styled.img`
  display: block;
  position: absolute;
  width: 84%;
  height: 100%;
  left: 85px;
  top: -134px;
  margin: 0 auto;
`;

const UpgradedScreenContainer = styled.div<{ boothColor: string }>`
  ${UpgradedBackdrop} path {
    fill: ${({ boothColor }) => boothColor};
  }
`;

const UpgradedBoothContents = styled.img`
  width: 88%;
  position: absolute;
  left: 69px;
  top: 0px;
`;

const UpgradedBorders = styled.img`
  display: block;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
`;

const ScreenBackground = ({ boothColor }) => (
  <UpgradedScreenContainer boothColor={boothColor}>
    <UpgradedBackdrop />
    <UpgradedBoothLinesImage src={UpgradedBoothLines} />
    <UpgradedBorders src={Booth711Borders} />
    <UpgradedBoothContents src={BoothTemplate04Backdrop} />
  </UpgradedScreenContainer>
);

ScreenBackground.propTypes = {
  boothColor: PropTypes.string,
};

ScreenBackground.defaultProps = {
  boothColor: undefined,
};

export default ScreenBackground;
